module.exports = "/_next/static/images/banner_icon_shokai-ecdbfc856598e09ab234fb33b0b0eda5.svg";